import styled, { css, keyframes } from 'styled-components';
import { colorVariables, fontVariables } from 'desktop/theme/variables';
import Text from 'desktop/components/Text';

export const LoaderStyled = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 99;

  ${(props) =>
    props.background &&
    css`
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      justify-content: center;
      transform: translate(0, 0);
      background-color: rgba(255, 255, 255, 0.95);
    `};
`;

export const LoaderContent = styled.div`
  position: relative;
`;

export const VideoSvg = styled.svg`
  position: relative;
  width: 125px;
  height: 4px;
`;

const Rotate = keyframes`
  from {
    transform: rotate(-42deg);
  }

  to {
    transform: rotate(318deg);
  }
`;

export const LoaderSvg = styled.svg`
  position: relative;
  width: 30px;
  height: 30px;
  transform-origin: center center;
  transform: rotate(-42deg);
  animation: ${Rotate} 915ms linear infinite;
`;

export const LoaderCircle = styled.circle`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  stroke: ${colorVariables.yellow_dark};
`;

export const StyledText = styled(Text)`
  position: relative;
  margin-top: 15px;
  font-size: ${fontVariables.fs_xxs};
`;
